import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

import { cn } from '@/app/utils/cn'
import {
  SUPPORT_REASON_LABEL,
  SUPPORT_STATUS_BADGE_CLASSNAME,
  SUPPORT_STATUS_LABEL,
  SupportRequest,
} from '@/app/entities/SupportRequest'
import { Badge } from '@/view/components/ui/badge'
import { Skeleton } from '@/view/components/ui/skeleton'

interface MobileSupportRequestListProps {
  supportRequests: SupportRequest[]
  isStaffView?: boolean
  onClick: (supportRequest: SupportRequest) => void
  isFetchingNextPage?: boolean
}

export const MobileSupportRequestList = ({
  supportRequests,
  isStaffView,
  onClick,
  isFetchingNextPage,
}: MobileSupportRequestListProps) => {
  return (
    <div className="flex flex-col gap-3">
      {supportRequests.map((supportRequest) => (
        <button
          key={supportRequest._id}
          onClick={() => onClick(supportRequest)}
          className={cn(
            'flex flex-col gap-2 rounded-xl border p-4 text-left',
            supportRequest.hasUnreadMessage && '[&_p]:font-bold',
          )}
        >
          <div className="flex items-center justify-between gap-2">
            <p className="flex items-center gap-2 font-semibold text-black01">
              #{supportRequest.number || '-'}
              {supportRequest.hasUnreadMessage && (
                <span
                  aria-label="Nova mensagem"
                  className="size-2 shrink-0 rounded-full bg-primary"
                />
              )}
            </p>
            <Badge
              className={cn(
                'border-transparent font-semibold',
                SUPPORT_STATUS_BADGE_CLASSNAME[supportRequest.status],
              )}
            >
              {SUPPORT_STATUS_LABEL[supportRequest.status]}
            </Badge>
          </div>

          <p className="text-sm font-medium text-black03">
            {SUPPORT_REASON_LABEL[supportRequest.reason] || '-'}
          </p>

          {isStaffView && (
            <p className="text-sm text-black04">
              {supportRequest.seller?.name ??
                supportRequest.metadata?.contact?.name ??
                '-'}
            </p>
          )}

          <p className="text-xs text-black04">
            Aberto em{' '}
            {format(new Date(supportRequest.createdAt), 'dd/MM/yyyy, HH:mm', {
              locale: ptBR,
            })}
          </p>
        </button>
      ))}

      {isFetchingNextPage && (
        <div className="mt-1 flex flex-col gap-2">
          {new Array(2).fill(0).map((_, i) => (
            <Skeleton key={i} className="h-[120px] w-full rounded-xl" />
          ))}
        </div>
      )}
    </div>
  )
}
